<template>
    <v-menu bottom offset-y left origin="top right" transition="scale-transition">
        <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="mr-5" color="#EFEFEF">
            <v-icon left medium>{{ icons.shareIcon }}</v-icon>
            <span class="button_text text-capitalize text_condensed">My Projects</span>
            <v-icon right medium>{{ icons.chevronDownIcon }}</v-icon>
        </v-btn>
        </template>

        <v-list class="pa-0">
            <v-list-item
                v-for="mod of current_modules" 
                :key="mod.module_id"
                :to="mod.projects[0].mroute"
                class="button_link"
                active-class=""
            >
            <v-icon left small>{{ mod.module_icon }}</v-icon>{{ mod.module_name }}
            </v-list-item>
        </v-list>
    </v-menu>
</template>


<script>
    import axios from 'axios'
    import appUrls from '../helpers/environment'
    import { mdiShareVariant, mdiChevronDown, mdiChevronUp } from '@mdi/js'

    export default {
        name: 'UserProjectsDropdown',

        data () {
            return {
                icons:{
                    shareIcon: mdiShareVariant,
                    chevronDownIcon: mdiChevronDown,
                    chevronUpIcon: mdiChevronUp
                },      
                current_modules: [],
            }
        },
        
        mounted () {
            if(Cookie.get('id')) this.getModules()
        },

        methods: {
            getModules: function () {
                axios.get(`${appUrls.api}/api/modules/${Cookie.get('id')}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    //console.log(res.data)
                    if (res.data.outcome) {
                        this.current_modules = res.data.modules.filter(row => {
                            return Object.keys(row.projects).length
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UserProjectsDropdown.vue